<template>
  <div class="negative">
    <h1 class="normal" id="page-title-for-sr">
      <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
      <span aria-live="assertive" role="status" v-html="$t('confirmation.negative.header')"></span>
    </h1>
    <p v-html="$t('confirmation.negative.description')"></p><p v-html="$t('confirmation.negative.description2')"></p>
  </div>
</template>

<script>
export default {
  name: 'ConfirmationNegative'
}
</script>
